import {
  Component,
  ElementRef,
  OnInit,
  Renderer2,
  ViewChild,
  HostListener
} from "@angular/core";
import { Router } from "@angular/router";
import { AdminService } from "../admin.service";

@Component({
  selector: "app-admin-sidebar",
  templateUrl: "./admin-sidebar.component.html",
  styleUrls: ["./admin-sidebar.component.css"],
})
export class AdminSidebarComponent implements OnInit {
  tripType: any = "-1";
  public isCollapsed = false;
  fetch_page: any = 1;
  token: any;
  permissions: string[] = [];
  isAdmin: boolean = false;
  profileLoaded: boolean = false;

  public opened = true;
  public mode: 'over' | 'push' | 'side' = 'side';
  public isMobile = false;

  constructor(
    private router: Router,
    private service: AdminService,
    private renderer: Renderer2
  ) { }
  @ViewChild("submenu1") submenu1: ElementRef;

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkScreenSize();
  }

  checkScreenSize() {
    if (window.innerWidth <= 991) {
      this.mode = 'over';
      this.isMobile = true;
      this.opened = false;
    } else {
      this.mode = 'side';
      this.isMobile = false;
      this.opened = true;
    }
  }

  ngOnInit(): void {
    this.checkScreenSize();
    this.service.toggleSidebar.subscribe(() => {
      this.opened = !this.opened;
    });

    let tripType = localStorage.getItem("tripType");
    if (!tripType || tripType == "dashboard") {
      this.tripType = "dashboard";
      this.router.navigateByUrl("/admin/dashboard");
    } else {
      this.tripType = tripType;
    }
    localStorage.removeItem("tripType");
    document.addEventListener("keydown", this.preventEscClose, true);
    this.token = localStorage.getItem("adminToken");
    this.getProfile();
  }

  getProfile() {
    this.service.profileGet(this.token).subscribe((res: any) => {
      if (res.status === 200) {
        const userData = res.body.data;
        this.permissions = userData.permissions || [];
        // If it's a super admin, they might not have employee_id or have role 'admin'
        this.isAdmin = userData.role === "admin" || !userData.employee_id;
        this.service.setPermissions(this.permissions, this.isAdmin);
        this.profileLoaded = true;
      }
    });
  }

  hasPermission(moduleId: string): boolean {
    return this.service.hasPermission(moduleId);
  }

  ngOnDestroy(): void {
    document.removeEventListener("keydown", this.preventEscClose, true);
  }
  getTripsList(selectedTripType: any) {
    this.tripType = selectedTripType;
    if (this.tripType == "trucks") {
      sessionStorage.removeItem("lastTruckFetchPage");
      sessionStorage.setItem("lastTruckFetchPage", this.fetch_page.toString());
      sessionStorage.removeItem("lastTruckTypeFetchPage");
      sessionStorage.removeItem("preOrderFirstLoad");
      sessionStorage.setItem(
        "lastTruckTypeFetchPage",
        this.fetch_page.toString()
      );
    }

    localStorage.setItem("tripType", this.tripType);

    if (this.tripType !== "trucks" && this.submenu1) {
      const submenuElement = this.submenu1.nativeElement;
      if (submenuElement.classList.contains("show")) {
        submenuElement.classList.remove("show");
      }
    }

    if (this.isMobile) {
      this.opened = false;
    }

    switch (this.tripType) {
      case "dashboard":
        sessionStorage.removeItem("preOrderFirstLoad");
        this.router.navigateByUrl("/admin/dashboard");
        break;

      // case "vendors":
      //   sessionStorage.removeItem("preOrderFirstLoad");
      //   this.router.navigateByUrl("/admin/vendors");
      //   break;
      case "vendors":
        sessionStorage.removeItem("preOrderFirstLoad");
        this.router.navigateByUrl("/", { skipLocationChange: true }).then(() => {
          this.router.navigateByUrl("/admin/vendors");
        });
        break;

      case "loads":
        sessionStorage.removeItem("preOrderFirstLoad");
        this.router.navigateByUrl("/admin/loads");
        break;
      case "drivers":
        sessionStorage.removeItem("lastDriverFetchPage");
        sessionStorage.removeItem("preOrderFirstLoad");
        sessionStorage.setItem(
          "lastDriverFetchPage",
          this.fetch_page.toString()
        );
        this.router.navigateByUrl("/admin/drivers");
        break;
      case "mapping":
        sessionStorage.removeItem("preOrderFirstLoad");
        this.router.navigateByUrl("/admin/mapping");
        break;
      case "driverOrders":
        sessionStorage.removeItem("preOrderFirstLoad");
        sessionStorage.removeItem("lastDriverOrdersFetchPage");
        sessionStorage.setItem(
          "lastDriverOrdersFetchPage",
          this.fetch_page.toString()
        );
        this.router.navigateByUrl("/admin/driverOrders");
        break;
      case "tax":
        sessionStorage.removeItem("preOrderFirstLoad");
        this.router.navigateByUrl("/admin/tax");
        break;
      case "gpsType":
        sessionStorage.removeItem("preOrderFirstLoad");
        this.router.navigateByUrl("/admin/gpsType");
        break;
      case "gps":
        sessionStorage.removeItem("preOrderFirstLoad");
        this.router.navigateByUrl("/admin/gps");
        break;
      case "documents":
        sessionStorage.removeItem("preOrderFirstLoad");
        this.router.navigateByUrl("/admin/documents");
        break;
      case "trips":
        sessionStorage.removeItem("preOrderFirstLoad");
        sessionStorage.removeItem("lastFetchPage");
        sessionStorage.removeItem("lastAdminTripType");
        sessionStorage.setItem("lastFetchPage", this.fetch_page.toString());

        this.router.navigateByUrl("/admin/trips");
        break;

      case "pre_orders":
        sessionStorage.removeItem("preOrderFirstLoad");
        this.router
          .navigateByUrl("/", { skipLocationChange: true })
          .then(() => {
            this.router.navigateByUrl("/admin/pre-order");
          });
        break;
      case "workorder":
        sessionStorage.removeItem("preOrderFirstLoad");
        // Reload the page by navigating to the same route
        sessionStorage.removeItem("lastWorderOrderFetchPage");
        sessionStorage.setItem(
          "lastWorderOrderFetchPage",
          this.fetch_page.toString()
        );
        this.router.navigateByUrl("/admin/workorder");
        break;
      case "payments":
        sessionStorage.removeItem("preOrderFirstLoad");
        this.router.navigateByUrl("/admin/payments");
        break;
      case "reports":
        sessionStorage.removeItem("preOrderFirstLoad");
        this.router.navigateByUrl("/admin/reports");
        break;
      case "invoice":
        sessionStorage.removeItem("preOrderFirstLoad");
        this.router.navigateByUrl("/admin/invoice");
        break;
      case "track":
        sessionStorage.removeItem("preOrderFirstLoad");
        this.router.navigateByUrl("/admin/track");
        break;
      case "track-new":
        sessionStorage.removeItem("preOrderFirstLoad");
        this.router.navigateByUrl("/admin/track-new");
        break;
      case "users":
        sessionStorage.removeItem("preOrderFirstLoad");
        this.router.navigateByUrl("/admin/users");
        break;
      case "promotional_notifications":
        sessionStorage.removeItem("preOrderFirstLoad");
        this.router.navigateByUrl("/admin/promotional-notifications");
        break;
      case "settings":
        sessionStorage.removeItem("preOrderFirstLoad");
        this.router.navigateByUrl("/admin/settings");
        break;
      case "web":
        sessionStorage.removeItem("preOrderFirstLoad");
        this.router.navigateByUrl("/admin/webPages");
        break;
    }
  }

  GoToDashboard() {
    this.router.navigateByUrl("/admin/dashboard");
    if (this.isMobile) this.opened = false;
  }

  toggleSidebar() {
    this.opened = false;
  }

  onOpenedChange(event: boolean) {
    this.opened = event;
  }

  preventEscClose = (event: KeyboardEvent): void => {
    if (
      (event.key === "Escape" || event.keyCode === 27) &&
      (event.target as HTMLElement).closest(".sidebar")
    ) {
      event.stopPropagation();
    }
  };
}
